import React, { useEffect, useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { PRIVACY_NOTICE_STORAGE_KEY } from '../../constants/privacyNotice';
import './PrivacyNoticeBanner.css';

const PrivacyNoticeBanner = () => {
  const location = useLocation();
  const [visible, setVisible] = useState(() => {
    try {
      return localStorage.getItem(PRIVACY_NOTICE_STORAGE_KEY) !== '1';
    } catch {
      return true;
    }
  });

  useEffect(() => {
    if (!visible || location.pathname === '/privacidad') {
      document.body.classList.remove('has-privacy-banner');
      return;
    }
    document.body.classList.add('has-privacy-banner');
    return () => document.body.classList.remove('has-privacy-banner');
  }, [visible, location.pathname]);

  const dismiss = () => {
    try {
      localStorage.setItem(PRIVACY_NOTICE_STORAGE_KEY, '1');
    } catch {
      /* ignore */
    }
    setVisible(false);
    document.body.classList.remove('has-privacy-banner');
  };

  if (!visible || location.pathname === '/privacidad') {
    return null;
  }

  return (
    <div className="privacy-notice-banner" role="region" aria-label="Aviso de privacidad">
      <div className="privacy-notice-banner__inner">
        <p className="privacy-notice-banner__text">
          Esta aplicación usa almacenamiento del navegador para la sesión y el funcionamiento del servicio,
          sin publicidad de terceros.{' '}
          <Link className="privacy-notice-banner__link" to="/privacidad">
            Más información
          </Link>
        </p>
        <button type="button" className="privacy-notice-banner__btn" onClick={dismiss}>
          Entendido
        </button>
      </div>
    </div>
  );
};

export default PrivacyNoticeBanner;
